export default __webpack_public_path__ + "static/media/svg-2.be1fd5ad.svg";